import { memo } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import RichTextPreview from '../../richTextPreview';
import UserAvatar from '../../userAvatar';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  title: {
    color: primary.indigo,
    wordBreak: 'break-word',
  },
  questionText: {
    color: primary.bluish1,
    marginTop: spacing(1),
  },
  answerWrapper: {
    marginTop: spacing(4),
  },
  replyWrapper: {
    boxSizing: 'border-box',
    border: `1px solid ${primary.bluish4}`,
    borderRadius: 16,
    marginTop: spacing(4),
    padding: spacing(4),
  },
  reply: {
    marginBottom: spacing(5),
  },
  userLabel: {
    fontFamily: 'ProximaNova-Bold',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    height: 18,
    fontSize: 14,
    lineHeight: '18px',
    color: primary.bluish1,
  },
}));

const VirtualComment = ({ translations, comment }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.title} variant="body2">
        {translations.question}
      </Typography>
      <Typography className={classes.questionText} variant="h4">
        {comment.questionText}
      </Typography>
      {comment.answers.map(answer => (
        <div key={`answer_item_${answer.id}`} className={classes.answerWrapper}>
          <Typography className={classes.title} variant="body2">
            {translations.answer}
          </Typography>
          <Typography className={classes.questionText} variant="h4">
            {answer.text}
          </Typography>
          {answer.replies.map((currentReply, index) => (
            <div key={`answer_reply_${index}`} className={classes.replyWrapper}>
              <RichTextPreview
                className={classes.reply}
                variant="body2"
                text={currentReply.reply}
              />
              <UserAvatar
                labelClass={classes.userLabel}
                user={currentReply.reviewer}
                caption
                small
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

VirtualComment.propTypes = {
  translations: PropTypes.object.isRequired,
  comment: PropTypes.object.isRequired,
};

export default memo(VirtualComment);
